import React, { memo, useMemo } from 'react';

import { Avatar, Box, Tooltip, Typography } from '@mui/material';
import { getAuthorAvatarBorderStyles } from 'app/shared/styles/authorAvatar.styles';
import PropTypes from 'prop-types';

import {
  getAuthorInitials,
  getExactDateTime,
  getRelativeTime,
} from '../../PendingChangesDrawer.utils';
import {
  authorInfoStyles,
  authorNameStyles,
  cardBottomRowStyles,
  timestampStyles,
} from '../PendingChangesCard/PendingChangesCard.styles';

import { RECALCULATED_CARD_TITLE } from './PendingChangesRecalculatedCard.constants';
import { recalculatedCardStyles, titleStyles } from './PendingChangesRecalculatedCard.styles';
import { PendingChangesRecalculatedCardTestIds } from './PendingChangesRecalculatedCard.testIds';

const PendingChangesRecalculatedCard = ({
  title = RECALCULATED_CARD_TITLE,
  formattedFullName = null,
  modifiedOn = null,
  authorColor = null,
}) => {
  const initials = useMemo(() => getAuthorInitials(formattedFullName), [formattedFullName]);

  const avatarBorderStyles = useMemo(() => getAuthorAvatarBorderStyles(authorColor), [authorColor]);

  const relativeTimestamp = useMemo(() => getRelativeTime(modifiedOn), [modifiedOn]);

  const exactTimestamp = useMemo(() => getExactDateTime(modifiedOn), [modifiedOn]);

  return (
    <Box data-testid={PendingChangesRecalculatedCardTestIds.CARD} sx={recalculatedCardStyles}>
      <Typography sx={titleStyles} variant="bold14">
        {title}
      </Typography>

      <Box sx={cardBottomRowStyles}>
        <Box sx={authorInfoStyles}>
          <Avatar sx={avatarBorderStyles}>{initials}</Avatar>
          <Typography sx={authorNameStyles} variant="regular12">
            {formattedFullName}
          </Typography>
        </Box>
        <Tooltip title={exactTimestamp}>
          <Typography sx={timestampStyles} variant="regular12">
            {relativeTimestamp}
          </Typography>
        </Tooltip>
      </Box>
    </Box>
  );
};

PendingChangesRecalculatedCard.propTypes = {
  title: PropTypes.string,
  formattedFullName: PropTypes.string,
  modifiedOn: PropTypes.string,
  authorColor: PropTypes.string,
};

export default memo(PendingChangesRecalculatedCard);
